import axiosClient from "@/utils/axios-client";
import { toSnakeKeyObject } from "@/utils/case";
import {
  PathPickProductRequestListResponse,
  PathPickRequestsResponse,
} from "@/features/pathpick/types/response";
import {
  PathPickProductRequestListParams,
  PathPickRequestsRequestParams,
} from "@/features/pathpick/types/request-params";

const url = {
  getPathPickRequests: (companyId: number) =>
    `/buyers/${companyId}/pathpick/requests`,
  getPathPickProductRequests: (companyId: number) =>
    `/buyers/${companyId}/pathpick/requests/product-list`,
};

export const pathPickSyncDownloadHistoryQueryApi = {
  // 연동/다운로드 요청 내역 목록 조회 (연동·엑셀 요청이 섞여 내려온다)
  getPathPickRequests: async (
    companyId: number,
    params?: PathPickRequestsRequestParams
  ) => {
    const { data } = await axiosClient.get<PathPickRequestsResponse>(
      url.getPathPickRequests(companyId),
      { params: params ? toSnakeKeyObject(params) : undefined }
    );
    return data;
  },
  // 상품별 요청 내역 조회 — 상품 단위로 묶고 채널별 처리결과 3종을 함께 내려준다.
  getPathPickProductRequests: async (
    companyId: number,
    params?: PathPickProductRequestListParams
  ) => {
    const { data } = await axiosClient.get<PathPickProductRequestListResponse>(
      url.getPathPickProductRequests(companyId),
      { params: params ? toSnakeKeyObject(params) : undefined }
    );
    return data;
  },
};
